import { useIntl } from '@/intl'
import { DurationDropdownFilter } from '@/scopes/prices/components/Filters/DurationDropdownFilter'
import { GroupedAirportFilter } from '@/scopes/prices/components/Filters/GroupedAirportFilter'
import { MealPlanFilter } from '@/scopes/prices/components/Filters/MealPlanFilter'
import { ParticipantsDropdownFilter } from '@/scopes/prices/components/Filters/ParticipantsDropdownFilter'
import { RoomTypeFilter } from '@/scopes/prices/components/Filters/RoomTypeFilter'
import { TransportTypeFilter } from '@/scopes/prices/components/Filters/TransportTypeFilter'
import { getFiltersSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { Button, Icon, tk, UnavailableContentDialog } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(234px, 1fr));
  column-gap: ${tk('spacing_lg')};
  padding: ${tk('spacing_lg')} ${tk('spacing_lg')} ${tk('spacing_sm')};
  height: auto;
  width: 100%;
  background: ${tk('color_semantic_bg_subdued')};

  @media (min-width: ${tk('breakpoint_desktop_lg')}) {
    > * {
      margin-bottom: ${tk('spacing_sm')};
    }
  }
`

export function Filters() {
  const intl = useIntl()
  const { error } = usePricesSelector(getFiltersSelector)

  if (error) {
    return (
      <UnavailableContentDialog
        icon={<Icon glyph="IconFaceSad" size="lg" />}
        title={intl.formatMessage({ id: 'prices_filters_error_title' })}
        message={intl.formatMessage({ id: 'prices_filters_error_message' })}
      >
        <Button onClick={() => window.location.reload()}>
          {intl.formatMessage({ id: 'prices_error_reload_button' })}
        </Button>
      </UnavailableContentDialog>
    )
  }

  return (
    <Wrapper>
      <ParticipantsDropdownFilter />
      <DurationDropdownFilter />
      <GroupedAirportFilter />
      <RoomTypeFilter />
      <MealPlanFilter />
      <TransportTypeFilter />
    </Wrapper>
  )
}
